import { DatePicker } from 'antd'

export declare type EventValue<DateType> = DateType | null
export declare type RangeValue<DateType> =
  | [EventValue<DateType>, EventValue<DateType>]
  | null

export const { RangePicker } = DatePicker
